<template>
  <div class="wrapper">
    <PrimaryCard id="container">
      <div class="title">Sorry, something went wrong.</div>
      <div class="description">The resource requested could not be found on this page.</div>
    </PrimaryCard>
  </div>
</template>

<script>
import { PrimaryCard } from '@mikmak/components';

export default {
  components: {
    PrimaryCard,
  },
};
</script>

<style scoped>
.wrapper {
  background: #F7FAFC;
  position: absolute;
  width: 100%;
  top: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100vh;
}

#container {
  height: 90px;
  padding: 35px;
  font-family: 'Work Sans';
}

.title {
  font-weight: 700;
  font-size: 32px;
  line-height: 125.3%;
}

.description {
  font-weight: 400;
  font-size: 24px;
  padding:14px;
}
</style>
